import { useMemo } from 'react'
import moment from 'moment'
import { groupBy } from 'lodash'
import { DateTime } from 'luxon'
import { useReselector } from '@/utils/sharedHooks'

import { Accordion, Card, CardColors, Text } from '@/ui'

// TODO: Migrate to V2
import { selectActiveQuarterlyTaxEstimateDetails } from '@/featuresV1/Admin/QuarterlyTaxEstimateDetails/quarterlyTaxEstimateDetails.selector'
import { selectPreviousQuarterTaxEstimatesForYear } from '@/featuresV1/Taxes/QuarterlyTaxEstimates/userTaxEstimates.selector'
import EstimateCard from '@/featuresV1/Taxes/AnnualTaxes/TaxChecklist/Form1040/AddMissingQTEPayments/EstimateCard'
import { useCompleteQTEActionItemIfNeeded } from '@/featuresV1/Taxes/QuarterlyTaxEstimates/service'
import { TypographyStyles } from '@/styles'

export const PreviousTaxPayments = () => {
  const activeQuarterDetails = useReselector(
    selectActiveQuarterlyTaxEstimateDetails
  )

  const currentQuarter = Number(activeQuarterDetails?.taxQuarter ?? 1)
  const year = Number(activeQuarterDetails?.taxYear ?? DateTime.now().year)

  const estimates = useReselector(
    selectPreviousQuarterTaxEstimatesForYear,
    year,
    currentQuarter
  )
  const groupedEstimates = useMemo(
    () => Object.entries(groupBy(estimates, (estimate) => estimate.taxQuarter)),
    [estimates]
  )

  useCompleteQTEActionItemIfNeeded()

  return (
    <div className="w-full space-y-6">
      <div className="w-full max-w-4xl mx-auto text-center">
        <Text variant={TypographyStyles.DISPLAY_LG}>
          Update your quarterly tax payments to receive your estimated tax
          payment
        </Text>
      </div>

      <Accordion
        className="w-full max-w-4xl mx-auto flex flex-col items-center"
        variant="text"
        type="single"
        items={[
          {
            title: 'Why does Heard need this?',
            content:
              "Updating your quarterly tax payments helps Heard calculate a more accurate estimate for you: we predict how much you'll owe in taxes for this year, and then subtract actual payments already made.",
          },
        ]}
      />

      {groupedEstimates.map(([key, estimates]) => (
        <div key={key} className="w-full">
          <Card color={CardColors.LEVEL_0} className="space-y-4 p-4">
            <Text variant={TypographyStyles.H2}>
              {moment(key, 'YYYY-Q').format('[Q]Q YYYY')}
            </Text>
            {estimates.map((estimate) => (
              <EstimateCard key={estimate.id} estimate={estimate} />
            ))}
          </Card>
        </div>
      ))}
    </div>
  )
}
